module.exports = __webpack_public_path__ + "img/truck-extra.eb8fcd55.png";